// @mui
import { styled } from '@mui/material/styles';
import { BaseReactPlayerProps } from 'react-player/base';
import ReactPlayer from 'react-player/vimeo';

// ----------------------------------------------------------------------

export const ReactPlayerStyle = styled(ReactPlayer)(() => ({
  width: '100% !important',
  height: '100% !important',
  '& video': {
    objectFit: 'cover',
  },
}));

// ----------------------------------------------------------------------

// https://github.com/CookPete/react-player

export default function Player({ ...other }: BaseReactPlayerProps) {
  return <ReactPlayerStyle {...other} />;
}
